<template>
  <div class="collection-filter text-center" v-if="sortedChildrenCategories && sortedChildrenCategories.length">
    <h4 class="-upper" v-text="$t('Collections')"></h4>
    <ul class="collection-filter__list d-flex flex-wrap justify-content-center font-small pl-0" id="link-category"
        aria-labelledby="link-category"
    >
      <li class="collection-filter__list--element" v-for="category in sortedChildrenCategories" :key="category.url_key">
        <router-link class="btn -stroke" :to="`${localizedUrl}/products/${category.url_key}`">
          {{ category.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  name: 'CollectionFilter',
  props: ['categories'],
  mixins: [ReadyHook],
  data () {
    return {}
  },
  computed: {
    sortedChildrenCategories () {
      return [...this.categories.children].sort((a, b) => (+a.position > +b.position ? 1 : -1))
    },
    localizedUrl() {
      const { url } = currentStoreView()
      return url || ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.collection-filter {
  margin: 0;
  padding: 3rem auto 4rem;
  border-bottom: 1px solid var(--zenith-grey-light);

  &__list {
    list-style: none;
    gap: 1rem;
    padding-bottom: 3rem;
    margin-bottom: 0;
    margin-inline: 2rem;

    &--element .btn {
      padding: 0.6rem 1.8rem;
      font-size: 1.2rem;
      font-weight: 300;
      min-height: unset;
    }
  }
}
</style>
